import axiosInstance from './axiosInstance'

export const getFabricationVendorById = (vendorId) => {
  return axiosInstance.get(`/fabrication-vendors/${vendorId}`)
}

export const getFabricationVendors = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/fabrication-vendors?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportFabricationVendors = ({ search = '', orderByKey = 'name', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/fabrication-vendors/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createFabricationVendor = (data) => {
  return axiosInstance.post('/fabrication-vendors', data)
}

export const updateFabricationVendor = (vendorId, data) => {
  return axiosInstance.put(`/fabrication-vendors/${vendorId}`, data)
}

export const deleteFabricationVendor = (vendorId) => {
  return axiosInstance.delete(`/fabrication-vendors/${vendorId}`)
}

export const getFabricationVendorNoteById = (vendorId, noteId) => {
  return axiosInstance.get(`/fabrication-vendors/${vendorId}/notes/${noteId}`)
}

export const getFabricationVendorNotes = (vendorId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/fabrication-vendors/${vendorId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createFabricationVendorNote = (vendorId, data) => {
  return axiosInstance.post(`/fabrication-vendors/${vendorId}/notes`, data)
}

export const updateFabricationVendorNote = (vendorId, noteId, data) => {
  return axiosInstance.put(`/fabrication-vendors/${vendorId}/notes/${noteId}`, data)
}

export const deleteFabricationVendorNote = (vendorId, noteId) => {
  return axiosInstance.delete(`/fabrication-vendors/${vendorId}/notes/${noteId}`)
}
